import React, { useState } from "react";
import "./LoginSignUp.css";
import { Link } from "react-router-dom";
import Spinner from "../../Spinner";
import axios from "axios";
import * as backendModule from "../../../modules/backendModule";
import { useDispatch } from 'react-redux';
import * as timestampActions from "../../../actions/timestampActions";
import animateModule from "../../../modules/animateModule";
import { useNavigate } from "react-router-dom";

const LoginSignUp = () => {
  const [activeTab, setActiveTab] = useState("tabButton1");
  const [spinner, setSpinner] = React.useState(false);
  const [message, setMessage] = React.useState(null);
  const [logged, setLogged] = React.useState(false);
  const passRef = React.useRef(null);
  const usernameRef = React.useRef(null);

  const curDispatch = useDispatch();

  const handleTab = (tab) => {
    setActiveTab(tab);
  };

  const mainNavigate = useNavigate();

  const animateNavigate = to => {
    animateModule(mainNavigate, to, document.querySelector(".route__contentWrapper"));
  };

  const checkLogin = () => {
    axios({
      method: "POST",
      url: `${backendModule.backendURL}/auth/checkLogin`,
      ...backendModule.axiosConfig
    }).then(res => {
      if (res.data.status === "ok") {
        if (res.data.data.UserInfo?.Flags?.isAdmin) {
          return animateNavigate('/admin/dashboard');
        }
      }
      else {
        return setLogged(false);
      }
    }).catch(() => {
      return setLogged(false);
    }).finally(() => {

    });
  };

  const loginHandler = () => {
    if (!usernameRef.current.value || !passRef.current.value) {
      return setMessage('Popunite sva polja!');
    }

    setSpinner(true);

    axios({
      method: "POST",
      url: `${backendModule.backendURL}/auth/login`,
      data: {
        username: usernameRef.current.value,
        password: passRef.current.value
      },
      ...backendModule.axiosConfig
    }).then(res => {
      if (res.data.status === "ok") {
        curDispatch(timestampActions.updateTimestamp());
        checkLogin();
        //props.setLogged(true);
      } else {
        return setMessage('Prijava nije uspjela');
      };
    }).catch(() => {
      return setMessage('Server ne reagira...');
    }).finally(() => {
      setSpinner(false);
    });
  }

  React.useEffect(() => {
    checkLogin();
  }, []);

  return (
    <>
      <div className="loginSignUpSection">
        <div className="loginSignUpContainer">
          <div className="loginSignUpTabs">
            <p
              onClick={() => handleTab("tabButton1")}
              className={activeTab === "tabButton1" ? "active" : ""}
            >
              Login
            </p>
          </div>
          <div className="loginSignUpTabsContent">
            {activeTab === "tabButton1" && (
              <div className="loginSignUpTabsContentLogin">
                <form>
                  <input ref={usernameRef} type="text" placeholder="Username *" required />
                  <input ref={passRef} type="password" placeholder="Password *" required />
                  {spinner ? <Spinner /> : <button onClick={()=>loginHandler()}>Log In</button>}
                  {message && <p>{message}</p>}
                </form>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default LoginSignUp;
